// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Cma-z","updatedSizingPrediction":"Dma-z","recommendedSize":"Ema-z","predictedSize":"Fma-z","recommendedSizeCopy":"Gma-z"};